import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { MetricCardData, SplitValueCardProps } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles } from "../../styles";

const renderTopRightValue = (topRightValue: MetricCardData["topRightValue"]) =>
  topRightValue && (
    <Stack direction="column" alignItems="flex-end">
      <Typography sx={operationsDashboardStyles.comparisonValue}>
        {topRightValue.value}
      </Typography>
      <Typography sx={operationsDashboardStyles.comparisonLabel}>
        {topRightValue.label}
      </Typography>
    </Stack>
  );

const renderMainValue = (data: SplitValueCardProps["data"]) =>
  data.unit?.includes("%") ? (
    <Typography
      sx={operationsDashboardStyles.valueText}
    >{`${data.value}${data.unit}`}</Typography>
  ) : (
    <Box sx={operationsDashboardStyles.flexCenter}>
      <Typography sx={operationsDashboardStyles.unitText}>
        {data.unit ?? ""}
      </Typography>
      <Typography sx={operationsDashboardStyles.valueText}>
        {data.value}
      </Typography>
    </Box>
  );

export const SplitValueCard: React.FC<SplitValueCardProps> = ({ data }) => {
  return (
    <BaseCard data={data}>
      <Box sx={operationsDashboardStyles.valueRow}>
        {renderMainValue(data)}
        {renderTopRightValue(data.topRightValue)}
      </Box>
      <Divider sx={operationsDashboardStyles.divider} />
      {data.splitValues && data.splitValues.length > 0 && (
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={operationsDashboardStyles.marginTop1}
        >
          {data.splitValues.map((item, index) => (
            <Stack
              key={`${item.label}-${item.value}`}
              direction="column"
              alignItems={index === 0 ? "flex-start" : "flex-end"}
            >
              <Typography sx={operationsDashboardStyles.comparisonValue}>
                {item.value}
              </Typography>
              <Typography sx={operationsDashboardStyles.comparisonLabel}>
                {item.label}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </BaseCard>
  );
};
